module.exports = __webpack_public_path__ + "img/cae7c5a.svg";